/**
 * API Configuration
 * Loads API URLs from environment variables with fallback to production URLs
 */
import axios from 'axios';

// Gửi cookie tự động cho mọi request cross-origin
axios.defaults.withCredentials = true;

// Base API URL
export const API_URL = process.env.REACT_APP_API_URL ?? "https://api.dhbtools.com";

// Admin API URL (most admin endpoints)
export const API_ADMIN_URL = process.env.REACT_APP_API_ADMIN_URL ?? "https://api.dhbtools.com/admin";

// Admin API v6 URL (newer user management endpoints)
export const API_ADMIN_V6_URL = process.env.REACT_APP_API_ADMIN_V6_URL ?? "https://api.dhbtools.com/admin/v6";

// Update API URL
export const API_UPDATE_URL = process.env.REACT_APP_API_UPDATE_URL ?? "https://api.dhbtools.com/admin/update";

// App API URL (language service)
export const API_APP_URL = process.env.REACT_APP_API_APP_URL ?? "https://api.dhbtools.com/app";

// Export all config as default object
const config = {
    API_URL,
    API_ADMIN_URL,
    API_ADMIN_V6_URL,
    API_UPDATE_URL,
    API_APP_URL,
};

export default config;
